import { render, staticRenderFns } from "./landingFooter.vue?vue&type=template&id=9b4e6e38&scoped=true"
import script from "./landingFooter.vue?vue&type=script&lang=js"
export * from "./landingFooter.vue?vue&type=script&lang=js"
import style0 from "./landingFooter.vue?vue&type=style&index=0&id=9b4e6e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4e6e38",
  null
  
)

export default component.exports